import React, { useState } from "react"

import { Box } from "components/common"
import {
  checkYotpoLoaded,
  reloadYotpo,
  yotpoJsUrl,
} from "helpers/external/yotpo"
import { shouldReloadWidget } from "helpers/lazyload"

const YotpoGetInspired = () => {
  const [widgetLoaded, setWidgetLoaded] = useState(false)

  return (
    <div
      className={`yotpo yotpo-pictures-widget${
        checkYotpoLoaded() ? "" : " lazyload"
      }`}
      data-gallery-id={sl.api.yotpo.galleries.inspo_gallery_id}
      data-script={yotpoJsUrl()}
      ref={(ref) => {
        if (!widgetLoaded && shouldReloadWidget(ref)) {
          reloadYotpo()
          setWidgetLoaded(true)
        }
      }}
    >
      <Box minHeight="80vh" my={6} textAlign="center">
        <Box
          as="img"
          height="175"
          mx="auto"
          src={require("images/layout/loadinglarge.gif")}
          width="175"
        />
      </Box>
    </div>
  )
}

export default YotpoGetInspired
